import {Component, OnInit, OnDestroy} from '@angular/core';
import {Notification} from '../interfaces/notification.interface';
import {Subject, takeUntil} from "rxjs";
import {NotificationsService} from "@core/services/backend/common/service/notifications.service";
import {NotificationsManagerService, NotificationData} from "@core/services/notifications/notifications-manager.service";
import {DateTime} from "luxon";
import {AuthService} from "@core/guard/auth-service";
import {
    ActivityAssignmentCommentsComponent
} from "@app/pages/activity-management/activity-assignment-comments/activity-assignment-comments.component";
import {MatDialog} from "@angular/material/dialog";
import {WorkedHoursService} from "@core/services/backend/common/service/workedHours.service";
import moment from "moment/moment";

@Component({
    selector: 'vex-toolbar-notifications-dropdown',
    templateUrl: './toolbar-notifications-dropdown.component.html',
    styleUrls: ['./toolbar-notifications-dropdown.component.scss']
})
export class ToolbarNotificationsDropdownComponent implements OnInit, OnDestroy {

    private readonly destroying$ = new Subject<void>();

    notifications: Notification[] = []
    length: number = 0;

    constructor(
        private notificationsService: NotificationsService,
        private notificationsManager: NotificationsManagerService,
        private dialog: MatDialog,
        private workedHoursService: WorkedHoursService,
        private authService: AuthService
    ) {}

    ngOnInit() {
        // Suscribirse a notificaciones del manager
        this.notificationsManager.getNotifications()
            .pipe(takeUntil(this.destroying$))
            .subscribe((notifications: NotificationData[]) => {
                this.processNotifications(notifications);
            });

        // Suscribirse al conteo de no leídas
        this.notificationsManager.getUnreadCount()
            .pipe(takeUntil(this.destroying$))
            .subscribe(count => {
                this.length = count;
            });

        // Iniciar polling
        this.notificationsManager.startPolling();
    }

    ngOnDestroy() {
        this.destroying$.next();
        this.destroying$.complete();
    }

    private processNotifications(data: NotificationData[]): void {
        let newData: Notification[] = [];
        this.length = 0;

        data.forEach((reg: NotificationData) => {
            const updatedAt = reg.updated_at || reg.created_at;
            if (!updatedAt) return;
            
            const date1 = DateTime.fromISO(updatedAt);
            const date2 = DateTime.now();
            const diff = date2.diff(date1, ["months", "days", "hours"]);

            if (String(this.authService.UserId) === String(reg.user_id)) {
                const readIt = reg.read_it || false;
                
                // Solo agregar notificaciones no leídas a la lista
                if (!readIt) {
                    this.length++;
                    
                    const notification: Notification = {
                        id: reg.id,
                        label: reg.message || '',
                        icon: 'mat:check_circle',
                        colorClass: (reg.message || '').indexOf('_OK') !== -1 ? 'text-primary' : 'text-red',
                        datetime: DateTime.fromISO(updatedAt).minus({
                            month: diff.months,
                            hour: diff.hours,
                            minute: diff.minutes
                        }),
                        read: false,
                        // Campos adicionales
                        type: reg.type || '',
                        message: reg.message || '',
                        aux_id: reg.aux_id || 0,
                        read_it: false,
                        user_id: reg.user_id || 0,
                        priority: reg.priority || 'normal',
                        category: reg.category || '',
                        action_url: reg.action_url || '',
                        expires_at: reg.expires_at || '',
                        metadata: reg.metadata || '',
                        created_at: reg.created_at || '',
                        updated_at: reg.updated_at || ''
                    };
                    
                    newData.push(notification);
                }
            }
        });

        this.notifications = newData;
    }

    markAllAsRead() {
        this.notificationsManager.markAllAsRead()
            .pipe(takeUntil(this.destroying$))
            .subscribe({
                next: () => {
                    // Las notificaciones se actualizan automáticamente por el manager
                },
                error: (err) => {
                    console.error('Error marcando todas como leídas:', err);
                }
            });
    }

    goNotification(notification: Notification) {
        const that = this;
        const notificationType = notification.type || '';
        
        switch (notificationType) {
            case 'WORKED_HOURS':
                const notificationSearch: any = {
                    id: notification.aux_id
                };
                
                this.workedHoursService.get(notificationSearch).subscribe({
                    next: (result: any) => {
                        const data: any = {
                            id: result.id,
                            user: result.user?.firstName + ' ' + result.user?.lastName,
                            project: result.project?.code + ' ' + result.project?.name,
                            date: moment(result.date).format('DD-MM-YYYY'),
                            status: result.status,
                            comments: result.comments,
                            statusComments: result.statusComment
                        };

                        that.dialog.open(ActivityAssignmentCommentsComponent, {
                            data: data,
                            disableClose: false,
                            width: '800px',
                            height: '400px'
                        }).afterClosed().subscribe(() => {
                            // Recargar notificaciones después de cerrar el diálogo
                            that.notificationsManager.refresh();
                        });
                    },
                    error: (err: any) => {
                        console.error('Error al cargar horas trabajadas:', err);
                    }
                });
                break;

            default:
                // Si hay una URL de acción, redirigir
                if (notification.action_url) {
                    // Implementar redirección si es necesario
                    console.log('Redirigir a:', notification.action_url);
                }
                break;
        }
    }
}
